export type LaborRateGapRecipe = {
  id: string;
  is_active: boolean;
  kind?: string;
};

export type LaborRateGapRate = {
  recipe_id: string | null;
  is_active?: boolean;
};

/** Active product SKUs with no active company rate. Models owns the SKU; this is the hole the rate catalog must fill. */
export function productRecipesMissingLaborRate<T extends LaborRateGapRecipe>(
  recipes: readonly T[],
  rates: readonly LaborRateGapRate[],
): T[] {
  const covered = new Set(
    rates
      .filter((rate) => rate.is_active !== false && rate.recipe_id)
      .map((rate) => rate.recipe_id as string),
  );
  return recipes.filter(
    (recipe) => recipe.is_active && (recipe.kind ?? "product") === "product" && !covered.has(recipe.id),
  );
}
